export const SEC_TO_MILLIS = 1000;
